import React from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useChallenge } from "@/contexts/ChallengeContext";
import { useImpersonation } from "@/contexts/ImpersonationContext";

export const GreetingSection = React.memo(function GreetingSection() {
  const { user } = useAuth();
  const { getCurrentDayTasks, activeChallengeLoadFailed } = useChallenge();
  const { isImpersonating, impersonatedUser } = useImpersonation();

  const userName = isImpersonating
    ? (impersonatedUser?.displayName || 'משתמש')
    : (user?.display_name || user?.email?.split('@')[0] || user?.phone || 'משתמש');
  const tasks = getCurrentDayTasks();
  const remainingTasks = tasks.filter(t => !t.completed).length;
  // Hebrew counts one and two as words: "משימה אחת", "שתי משימות" — never "1 משימות".
  const remainingPhrase =
    remainingTasks === 1 ? 'משימה אחת'
      : remainingTasks === 2 ? 'שתי משימות'
      : `${remainingTasks} משימות`;
  
  return (
    <div className="text-right" dir="rtl">
      <h1 className="text-3xl font-semibold text-foreground leading-tight">
        {/* bdi isolates a Latin or numeric fallback (e-mail prefix, "+972…") from
            the Hebrew around it. A number has no strong character for dir=auto to
            go by, so it's pinned LTR — otherwise "+972…" rendered as "…972+". */}
        שלום, <bdi data-private dir={/^[+\d\s-]+$/.test(userName) ? 'ltr' : 'auto'}>{userName}</bdi>
      </h1>
      {/* A failed load isn't "0 tasks left" — say nothing rather than something false.
          Nor is having no tasks today: it said "נשאר לך להשלים 0 משימות". */}
      {!activeChallengeLoadFailed && tasks.length > 0 && (
        <p className="mt-1 text-base text-muted-foreground">
          {remainingTasks === 0 ? (
            'השלמת את כל המשימות של היום'
          ) : (
            <>נשאר לך להשלים <span className="font-semibold text-foreground">{remainingPhrase}</span></>
          )}
        </p>
      )}
    </div>
  );
});